<template>
  <AppSidebar />
  <div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
    <AppHeader />
    <!-- Die Kopfleiste liegt fest und belegt keinen Platz im Fluss mehr; der
         Abstand traegt ihre gemessene Hoehe plus den bisherigen mb-3. -->
    <div class="body flex-grow-1 px-2 px-md-3 body-below-header">
      <CContainer fluid>
        <router-view />
      </CContainer>
    </div>
    <AppFooter />
  </div>
</template>
<script>
import { CContainer } from '@coreui/vue-pro'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppFooter,
    AppHeader,
    AppSidebar,
    CContainer,
  },
}
</script>

<style scoped>
.body-below-header {
  padding-top: calc(var(--app-header-height, 64px) + 1rem);
}
</style>